import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners } from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { appRoutes } from './app.routes';
import { crmAuthInterceptor } from './auth/crm-auth.interceptor';
import { crmAuthErrorInterceptor } from './auth/crm-auth-error.interceptor';
import { requestDedupInterceptor } from './request-dedup.interceptor';
import {
  API_TOAST_OWNS_UNAUTHORIZED,
  apiToastInterceptor,
} from '../../../../libs/core/service/api-toast.interceptor';
import { AppErrorHandler } from './core/app-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    // provideZonelessChangeDetection() was removed intentionally.
    //
    // This app uses the classic zone.js change detection model:
    //   - RxJS .subscribe() callbacks that mutate normal component properties
    //   - PrimeNG components that rely on zone-based CD
    //   - NgZone.run() calls in existing components
    //   - No signals-only state management
    //
    // Zoneless CD requires ALL state to be Angular signals or use the async pipe.
    // Without zone.js, templates only refresh on user interactions (click/scroll),
    // which is exactly the "stale UI after API calls" bug we experienced.
    //
    // zone.js is imported in main.ts — Angular auto-detects it and uses it.
    { provide: ErrorHandler, useClass: AppErrorHandler },
    // crmAuthErrorInterceptor is the single owner of 401: it refreshes the token
    // when possible and otherwise runs a full logout (cookies, branding,
    // permissions, logout API) with a session-expired toast. apiToastInterceptor
    // must not also react to 401 — it only sees mutations and its shallow logout
    // would race the refresh.
    { provide: API_TOAST_OWNS_UNAUTHORIZED, useValue: false },
    provideClientHydration(withEventReplay()),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(
      withFetch(),
      withInterceptors([crmAuthInterceptor, crmAuthErrorInterceptor, requestDedupInterceptor, apiToastInterceptor]),
    ),
    // Lazy chunks are preloaded in the background after the app is interactive,
    // so navigating between feature modules is instant without slowing first load.
    provideRouter(appRoutes, withPreloading(PreloadAllModules)),
  ],
};
